var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcWarning(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.8921 54.0433C36.8921 51.7066 38.0288 50.5366 40.3054 50.5366C41.4221 50.5366 42.2721 50.8433 42.8621 51.4533C43.4488 52.0666 43.7454 52.9299 43.7454 54.0433C43.7454 55.1433 43.4454 56.0166 42.8488 56.6566C42.2554 57.2999 41.4054 57.6233 40.3054 57.6233C39.2054 57.6233 38.3621 57.3099 37.7721 56.6799C37.1854 56.0533 36.8921 55.1766 36.8921 54.0466V54.0433Z",
    fill: "#F5A524"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.412 23.3333H37.412V46.6667H43.412V23.3333Z",
    fill: "#F5A524"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4121 40C10.4121 23.44 23.8521 10 40.4121 10C56.9721 10 70.4121 23.44 70.4121 40C70.4121 56.56 56.9721 70 40.4121 70C23.8521 70 10.4121 56.56 10.4121 40ZM40.4121 16C27.1658 16 16.4121 26.7537 16.4121 40C16.4121 53.2463 27.1658 64 40.4121 64C53.6584 64 64.4121 53.2463 64.4121 40C64.4121 26.7537 53.6584 16 40.4121 16Z",
    fill: "#F5A524"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcWarning);
export default __webpack_public_path__ + "static/media/ic-warning.3454fddb6ef5739029fdffec18abae64.svg";
export { ForwardRef as ReactComponent };